<template>
  <div>
    <nav-bar></nav-bar>
    <b-breadcrumb>
      <b-breadcrumb-item
        v-for="(item, index) in breadcrumbItems"
        :key="index"
        :href="item.href"
        :active="item.active"
      >
        <i v-if="item.icon" :class="item.icon"></i>
        <strong>{{ item.text }}</strong>
      </b-breadcrumb-item>
    </b-breadcrumb>
    <b-card no-body>
      <b-card-header class="sticky-top" header-tag="nav" header-bg-variant="light">
        <b-nav pills>
          <b-nav-item
            exact exact-active-class="active"
            v-for="language in languages"
            :key="language.languageId"
            :to="`/home/${language.code}`"
          >
            {{ language.name }}
          </b-nav-item>
        </b-nav>
      </b-card-header>
      <b-card-body>
        <keep-alive>
          <router-view :languages="languages" :key="$route.params.code"></router-view>
        </keep-alive>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import NavBar from "@/components/HomeNav.vue";
import { getLanguages } from "@/api/home";
import { mapState, mapMutations } from "vuex";
export default {
  name: "HomeView",
  components: {
    NavBar
  },
  mounted() {
    this.getLanguages();
    const message = this.homeToast;
    const variant = 'info';
    this.showToast(message, variant);
  },
  data() {
    return {
      languages: [],
      /** toast显示的信息 */
      homeToast: process.env.VUE_APP_HOME_TOAST,
      hideDelay: parseInt(process.env.VUE_APP_TOAST_HIDE_DELAY),
      title: process.env.VUE_APP_TITLE
    };
  },
  computed: {
    /** 存入store的会员信息 */
    ...mapState('auth', ['currentUser']),
    /** 面包屑 */
    breadcrumbItems() {
      return [
        {
          text: process.env.VUE_APP_BREADCRUMB_HOME || 'Home',
          href: process.env.VUE_APP_HOME_URL || 'https://johnslanguages.com',
          icon: 'fa-solid fa-house' // 首页添加图标
        },
        {
          text: process.env.VUE_APP_BREADCRUMB_LANGUAGES || 'Language Studies',
          href: process.env.VUE_APP_LANGUAGES_URL || 'https://johnslanguages.com/en',
          icon: 'fa-regular fa-folder-open'
        },
        {
          text: process.env.VUE_APP_BREADCRUMB_COURSES || 'Language Courses',
          active: true
        }
      ];
    }
  },
  methods: {
    /** 认证成功，取得会员信息后，把会员信息存入store */
    ...mapMutations('auth', ['setCurrentUser']),
    /** 查询课程的所有外语列表 */
    async getLanguages() {
      try {
        this.languages = await getLanguages();
      } catch (error) {
        console.error("语言列表获取失败:", error.message);
      }
    },
    /** 进入Home页面后，显示广告信息 */
    showToast(message, variant) {
      this.$bvToast.toast(message, {
        title: this.title,
        autoHideDelay: this.hideDelay || 1000,
        solid: true,
        variant: variant,
        toaster: 'b-toaster-top-center'
      });
    }
  }
}
</script>

<style scoped>

</style>
